import angular from 'angular';
import $ from 'jquery';

export default class UserProductPreview {
  constructor($scope, $rootScope, UserProductService) {
    var ko_product_model = new window.UserProductModel(window.user_id);
    var ko_product_volume_model = new window.UserProductVolumeModel(window.user_id);

    $scope.load_user_product = function() {
      UserProductService.get_preview_data(window.user_product_id).then(function(data) {
        $scope.user_product = data.user_product;
      });
    };

    $scope.edit_properties = function() {
      var dialog = $('div#edit_user_product_dialog');
      dialog.find('input[name="user_product_id"]').val(window.user_product_id);
      UserProductService.get(window.user_product_id).then(function(data) {
        ko_product_model.populateEditDialog(dialog, data.user_product);
        $.fancybox(dialog, {
          padding: '5',
          scrolling: 'no',
          openEffect: 'elastic',
          closeEffect: 'elastic',
          openSpeed: '700',
          closeSpeed: '300',
          afterClose: function() {
            $scope.load_user_product();
          }
        });
      });
    };

    $scope.edit_volumes = function() {
      var dialog = $('div#edit_volumes_dialog');
      ko_product_volume_model.populateEditVolumes(dialog, $scope.user_product);
      $.fancybox(dialog, {
        padding: '5',
        scrolling: 'no',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        afterClose: function() {
          $scope.load_user_product();
        }
      });
    };
    $scope.edit_pricings = function() {
      $scope.set_pricings_selected_tab(0);
      var dialog = $('div#edit_pricings_dialog');
      $.fancybox(dialog, {
        padding: '5',
        scrolling: 'no',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        afterShow: function() {
          UserProductService.get_user_product_pricings(window.user_product_id).then(function(data) {
            $scope.dialog_user_product = data.user_product;
          });
        },
        afterClose: function() {
          $scope.dialog_user_product = null;
          $scope.load_user_product();
        }
      });
    };
    $scope.add_product_row = function(delivery_term_id) {
      var pricing = {
        user_product_pricing: angular.copy(window.product_pricing)
      };
      pricing.user_product_pricing.user_product_id = $scope.dialog_user_product.id;
      pricing.user_product_pricing.delivery_term_id = delivery_term_id;
      $scope.dialog_user_product.pricings.push(pricing);
    };

    $scope.add_product_brand_row = function(brand, delivery_term_id) {
      var pricing = {
        user_product_brand_pricing: angular.copy(window.product_brand_pricing)
      };
      pricing.user_product_brand_pricing.user_product_brand_id = brand.id;
      pricing.user_product_brand_pricing.delivery_term_id = delivery_term_id;
      brand.pricings.push(pricing);
    };
    $scope.pricing_tabs = [
      {
        title: 'CFR',
        delivery_term_id: 1
      },
      {
        title: 'FCA',
        delivery_term_id: 3
      },
      {
        title: 'DAP',
        delivery_term_id: 2
      }
    ];
    $scope.set_pricings_selected_tab = function(index) {
      $scope.pricings_selected_tab = index;
    };
    $scope.set_product_pricings = function() {
      var count = 0;
      angular.forEach($scope.user_products, function(p) {
        if (p.has_pricings)
          count++;
      });
      var percentage = Math.floor(count / $scope.user_products.length * 100.0);
      $rootScope.$broadcast('set_sidebar_data', [0, 6, [{
        type: 'counter',
        value: count
      }, {
        type: 'percentage',
        value: percentage
      }]]);
    };

    $scope.save_pricings = function() {
      $scope.saving_pricings = true;
      UserProductService.save_pricings($scope.dialog_user_product).then(function(/*data*/) {
        $scope.saving_pricings = false;
      });
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.open_dialog = function(dialog_id) {
      $.fancybox($('div#' + dialog_id), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        afterClose: function() {
          $scope.load_user_product();
        }
      });
    };

    $scope.open_edit_specs_dialog = function() {
      $scope.$broadcast('open_edit_specs_dialog', {
        user_product_id: window.user_product_id
      });
    };

    $scope.init = function() {
      $scope.load_user_product();
      window.setGroupTabsAction();
      $('select[name="category_id"]').change(function() {
        window.get_groups_by_category($(this).parents('form').find('select[name="group_id"]'), $(this).val());
        window.get_product_properties_by_category($(this).parents('form'), $(this).val());
      });
      $('select[name="group_id"]').change(function() {
        window.get_products_by_group($(this).parents('form'), $(this).val());
        if ($(this).val() !== '')
          window.get_product_properties_by_group($(this).parents('form'), $(this).val());
      });
      $('select[name="product_id"]').change(function() {
        window.set_user_product_properties($(this).parents('form'), $(this));
      });
      $('select[name="product_printing_methods[]"], select[name="product_colors[]"]').select2({
        containerCssClass: 'multiselect2',
        dropdownCssClass: 'multiselect2',
        width: '150px'
      });
      window.ko.applyBindings(ko_product_model, $('#ko_container')[0]);
      window.ko.applyBindings(ko_product_volume_model, $('#edit_volumes_dialog')[0]);
      window.init_volumes_dialog();
    };
    $scope.init();
  }
}

UserProductPreview.$inject = ['$scope', '$rootScope', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-preview.ctrl.js